/* eslint-disable react/react-in-jsx-scope */
const Required = () => {
  return <span style={{ color: 'red', marginLeft: '3px' }}>*</span>
}
export default Required
